<template>
  <div class="proposal__wrap">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs__wrap">
      <el-breadcrumb-item :to="{ path: '/school' }">学校管理</el-breadcrumb-item>
      <el-breadcrumb-item>院系列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params">
        <el-form-item label="" prop="name">
          <el-input clearable v-model="table.params.name" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询 </el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" icon="el-icon-plus" size="mini" @click="showEdit">添加院系</el-button>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=''
        addText='添加'
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page='table.params.page'
        :pageSize='table.params.count'
        :total='table.total'
        :tree-props="{children: 'children', hasChildren: 'has_child'}"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:image="{row}">
          <el-image 
          style="width: 100px; height: 50px"
          :src="row.image" 
          :preview-src-list="[row.image]"
          fit="cover">
        </el-image>
        </template>
        <template v-slot:action="{row}">
          <el-button type="text" size="mini" @click="pushPage(row)">专业</el-button>
          <el-button type="text" icon="el-icon-edit" @click="showEdit(row)">编辑</el-button>
        </template>
      </VTable>
    </div>

    <edit ref="edit" @refresh="getTable" :schoolId="this.table.params.school_id"></edit>
    
  </div>
</template>

<script>
import VTable from '@/components/VTable';
import Edit from './components/Edit.vue'
import { mixinTable } from '@/mixins/table.js'
export default {
  name: 'FacultyList',
  mixins:[mixinTable],
  components: {
    VTable,
    Edit,
  },
  data() {
    return {
      field: [
        { name: "name", label: "院系名称", hidden: false },
        { name: "update_time", label: "更新时间", hidden: false },
        { name: "action", label: "操作", fixed:"right", width: "160", hidden: false }
      ],
      table: {
        loading: false,
        params: {
          name: "",
          school_id: sessionStorage.getItem('schoolId'),
          page: 1,
          count: 10
        },
        data: [],
        total: 0,
      },
      
    }
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http.get('/admin/faculty/list', { params: this.table.params }).then(res => {
        if(res.code === 1) {
           this.table.data = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    showEdit(row) {
      let dom = this.$refs.edit
      dom.toggle(true)
      if (!!row.id) {
        dom.getDetail(row)
      }
      dom = null
    },
    pushPage(row) {
      sessionStorage.setItem('facultyId', row.id)
      this.$router.push({
        path: '/major',
        query: {
          facultyId: row.id,
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
  .proposal__wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;

    .filter__wrap {
      padding: 10px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }

    .table__wrap {
      flex: 1;
      padding: 0;
      box-sizing: border-box;
    }

    .crumbs__wrap {
      margin-bottom: 20px;
    }
  }
</style>